const triggerPadding = 16;

const getFloatingSelectPosition = (trigger, floatingSelect, isMobile) => {
  if (!trigger || !floatingSelect) {
    return;
  }
  const viewportOffset = trigger.getBoundingClientRect();
  const elementWidth = trigger.offsetWidth || 0;
  const floatingSelectWidth = floatingSelect.clientWidth;
  const floatingSelectHeight = floatingSelect.offsetHeight;
  const top = viewportOffset.top;
  const left = viewportOffset.left;

  const style = trigger.currentStyle || window.getComputedStyle(trigger);
  const elementSpacingBottom = parseFloat(style.paddingBottom || 0) + parseFloat(style.marginBottom || 0);

  const regularTop = top - elementSpacingBottom;
  const invertedTop = top - floatingSelectHeight - triggerPadding - 40;

  const regularLeft = left - triggerPadding;
  const leftAlignLeft = left + elementWidth / 2 - 12;
  const rightAlignLeft = left + elementWidth - floatingSelectWidth;

  const invertY = regularTop > document.body.clientHeight - floatingSelectHeight - 120;
  if (invertY) {
    floatingSelect.classList.add('inverted-y');
  }

  const leftAlign = regularLeft <= 0;
  if (leftAlign) {
    floatingSelect.classList.add('left-align');
  }

  const rightAlign = regularLeft + floatingSelectWidth >= document.body.clientWidth;
  if (rightAlign) {
    floatingSelect.classList.add('right-align');
  }

  let finalTop = invertY ? invertedTop : regularTop;
  let finalLeft = leftAlign ? leftAlignLeft : rightAlign ? rightAlignLeft : regularLeft;

  finalLeft = isMobile ? 0 : finalLeft;
  finalTop = isMobile ? undefined : finalTop;
  finalLeft = isNaN(finalLeft) ? 0 : finalLeft;
  finalTop = isNaN(finalTop) ? 0 : finalTop;

  return { top: finalTop, left: finalLeft, invertY, leftAlign, rightAlign };
};

export default getFloatingSelectPosition;
